/*
 * @Author: wha wha01707839@intime.com.cn
 * @Date: 2025-07-16 10:11:05
 * @LastEditors: wha wha01707839@intime.com.cn
 * @LastEditTime: 2025-08-18 10:44:22
 * @FilePath: /mj-weex-basic/src/hooks/useUrlParams.ts
 * @Description: 
 * 
 */
import { useEffect, useState } from "react";
import { canIUse, Permission } from '@ali/hyper-api';
import { PermissionKeyType } from '@ali/hyper-api-permission';
import { usePermission } from './usePermission';
import Dialog from "@ali/bara-uikit-dialog";
import { deviceInfo } from '@ali/bara-uni-api';
export interface UrlParams {
  [key: string]: string;
}
export interface PermissionWords {
  title: string;
  key: PermissionKeyType[];
  name: string;
  content: string;
}
export interface PermissionStatus {
  [key: string]: string;
}
export interface UseUrlParamsReturn {
  urlParams: UrlParams;
  getPermissionWords: (id: number) => PermissionWords;
  getPermission: (item: PermissionWords) => void;
}
export const useUrlParams = (): UseUrlParamsReturn => {
  const {
    checkPermission
  } = usePermission();
  const [urlParams, setUrlParams] = useState<UrlParams>({});
  const [permissionStatus, setPermissionStatus] = useState('');
  const [hasShownDialog, setHasShownDialog] = useState(false);

  // 定义权限话术
  const permissionMap = {
    1: {
      title: '麦克风',
      key: [PermissionKeyType.RECORD_AUDIO],
      name: '为什么需要获取我的麦克风?',
      content: '我们访问您的麦克风是为了帮助您与品牌导购或客服实现语音交互，在这些功能中我们会收集您的录音内容实现语音聊天、或响应您的客服及争议处理等需求。请您知晓，即使您已同意开启麦克风权限，我们也仅会在您主动点击客户端内麦克风图标或录制视频时通过麦克风获取语音信息。'
    },
    2: {
      title: '相册',
      key: [PermissionKeyType.READ_IMAGES, PermissionKeyType.WRITE_IMAGES],
      name: '为什么需要获取我的相册?',
      content: '用于帮助您发布信息（如上传您的照片/图片/视频，以实现更换头像、发表评论/分享、拍照购物或与客服沟通提供证明），在本地记录崩溃日志信息（如有）等功能。我们可能会通过您所上传的照片/图片来识别您需要购买的商品或服务，或使用包含您所上传照片或图片的评论信息。允许App写入/下载/保存/修改/删除图片、文件、崩溃日志等信息，以保障客户端的稳定运行。'
    },
    3: {
      title: '位置信息',
      key: [PermissionKeyType.COARSE_LOCATION, PermissionKeyType.FINE_LOCATION],
      name: '为什么需要获取我的位置信息?',
      content: '我们访问您的位置信息是为了用于完成安全保障服务及基于地理位置的服务（LBS）等相关功能。我们会在您开启位置权限后访问获取您的位置信息，根据您的位置信息为您提供更契合您需求的页面展示、产品及/或服务（比如向您推荐附近的门店或可购商品信息）。'
    },
    4: {
      title: '相机',
      key: [PermissionKeyType.TAKE_CAMERA],
      name: '为什么需要获取我的相机?',
      content: '我们访问您的相机是为了进行扫码用于购物、领取优惠信息（如扫描购物小票后获取优惠券等形式）、直接拍摄并上传照片用于评价、分享，以及参与活动等您明确知悉的场景。'
    },
    5: {
      title: '日历',
      key: [PermissionKeyType.READ_CALENDAR, PermissionKeyType.WRITE_CALENDAR],
      name: '为什么需要获取我的日历?',
      content: '我们访问您的日历是为了用于在日历中添加领取权益、活动的日程提醒。'
    },
    6: {
      title: '通讯录',
      key: [PermissionKeyType.READ_CONTACTS, PermissionKeyType.WRITE_CONTACTS],
      name: '为什么需要获取我的通讯录?',
      content: '我们访问您的通讯录是为了使您在购物时可以更便利地取用您通讯录内的联系人信息，无需再手动输入。'
    },
    7: {
      title: '广告标识符',
      key: [PermissionKeyType.READ_TRACKING],
      name: '为什么需要获取我的广告标识符?',
      content: '我们访问您的广告标识符是为了用于追踪广告和信息的推送，为您提供更精准的推荐服务。'
    }
  };
  // 根据 id 获取对应话术
  const getPermissionWords = (id: number) => {
    return permissionMap[id];
  };
  // 获取权限
  const getPermission = (item: PermissionWords) => {
    if (permissionStatus === '已允许') {
      // 显示弹窗提示
      Dialog.alert({
        title: '提示',
        content: '请在手机系统"设置"中进行授予，尝试查找"应用管理""权限设置"等关键词'
      });
      return;
    }
    if (canIUse(Permission.request)) {
      Permission.request({
        permissions: item.key,
        privacyID: 'mjmt',
        description: item.name,
        silenceTime: 588,
        onSuccess: res => {
          console.log('res', res);
          // if(!deviceInfo.OS.isAndroid){
          //   return
          // }
          // // 根据 item.key 获取权限状态
          // const resultKey = Object.keys(res).filter((key:any) => item.key.includes(key))
          // if(resultKey.length <= 0){
          //   return
          // }
          // // 检查是否有任何权限被拒绝
          // const hasDeniedPermission = resultKey.some((key:any) => res[key] === 'DENIED')
          // if(hasDeniedPermission && !hasShownDialog){
          //   Dialog.alert({
          //     title: '提示',
          //     content: '请在手机系统"设置"中进行授予，尝试查找"应用管理""权限设置"等关键词',
          //   })
          //   setHasShownDialog(true)
          // }
        }
      });
    }
  };
  const getUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    const paramObj: UrlParams = {};
    for (let [key, value] of params.entries()) {
      paramObj[key] = decodeURIComponent(value);
    }
    setUrlParams(paramObj);
    if (paramObj.id) {
      const key = permissionMap[paramObj.id].key;
      checkPermission(key).then(res => {
        console.log(res);
        setPermissionStatus(res);
      });
    }
  };
  useEffect(() => {
    getUrlParams();
  }, []);
  return {
    urlParams,
    getPermissionWords,
    getPermission
  };
};